"use strict";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _nullishCoalesce(lhs, rhsFn) {
    if (lhs != null) {
        return lhs;
    } else {
        return rhsFn();
    }
}
var _chunkDSPWNYKZjs = require("./chunk-DSPWNYKZ.js");
var _chunk3KNDPG6Yjs = require("./chunk-3KNDPG6Y.js");
// src/utils/utils.ts
var _ = require("buffer/");
var _2 = _interopRequireDefault(_);
var _axios = require("axios");
var _axios2 = _interopRequireDefault(_axios);
function urlEncodeBase64(str) {
    var b64Chars = {
        "+": "-",
        "/": "_",
        "=": ""
    };
    return str.replace(/[+/=]/g, function(m) {
        return _nullishCoalesce(b64Chars[m], function() {
            return "";
        });
    });
}
function encodeState(state) {
    return _2.default.Buffer.from(JSON.stringify(state)).toString("base64");
}
var RequestBuilder = /*#__PURE__*/ function() {
    function RequestBuilder() {
        _class_call_check(this, RequestBuilder);
    }
    _create_class(RequestBuilder, [
        {
            key: "get",
            value: function get(requestUrl) {
                var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var _this = this;
                return _async_to_generator(function() {
                    var _;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _ = _this.ValidateHTTPResponse;
                                return [
                                    4,
                                    _axios2.default.get(requestUrl, options)
                                ];
                            case 1:
                                return [
                                    2,
                                    _.apply(_this, [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "post",
            value: function post(requestUrl, data) {
                var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                var _this = this;
                return _async_to_generator(function() {
                    var _;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _ = _this.ValidateHTTPResponse;
                                return [
                                    4,
                                    _axios2.default.post(requestUrl, data, options)
                                ];
                            case 1:
                                return [
                                    2,
                                    _.apply(_this, [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "ValidateHTTPResponse",
            value: function ValidateHTTPResponse(HTTPRawResponse) {
                return Promise.resolve(HTTPRawResponse.data);
            }
        }
    ]);
    return RequestBuilder;
}();
_chunk3KNDPG6Yjs.__decorateClass.call(void 0, [
    _chunkDSPWNYKZjs.validateRequest
], RequestBuilder.prototype, "get", 1);
_chunk3KNDPG6Yjs.__decorateClass.call(void 0, [
    _chunkDSPWNYKZjs.validateRequest
], RequestBuilder.prototype, "post", 1);
_chunk3KNDPG6Yjs.__decorateClass.call(void 0, [
    _chunkDSPWNYKZjs.validateResponseStatus
], RequestBuilder.prototype, "ValidateHTTPResponse", 1);
exports.urlEncodeBase64 = urlEncodeBase64;
exports.encodeState = encodeState;
exports.RequestBuilder = RequestBuilder;
